import {
    AnimationBaseController,
    FullScreenManager,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../Logic/GameLogic';
import { AnimationContents } from '../../../AnimationContents';
import { GameModel, QuestStateEnum } from '../../Models/GameModel';
import { UIButtonTopController } from './UIButtonTopController';
import { UIScoreController } from './UIScoreController';
import { UITimeController } from './UITimeController';
import { UITaskListController } from './UITaskListController';
import { UIQuestPointerController } from './UIQuestPointerController';
import { MiniGameTypeEnum } from '../../Models/MiniGameModel';

export class UIController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('UIController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'top_panel_container',
            childControllers: {
                UIButtonsTopController: {
                    instanceName: 'buttons_top_menu',
                    controller: UIButtonTopController,
                    model: this.$model,
                },
                UIScoreController: {
                    instanceName: 'score_menu',
                    controller: UIScoreController,
                    model: this.$model.player,
                },
                UITimeController: {
                    instanceName: 'time_menu',
                    controller: UITimeController,
                    model: this.$model.player,
                },
                UITasksController: {
                    instanceName: 'tasks_menu',
                    controller: UITaskListController,
                    model: this.$model,
                },
            },
            modelWatch: {
                'gamePad.showGamePad': (value: boolean) => {
                    this.visible = value;
                }
            },
            modelEvents: {
                onMiniGameComplete: (type: MiniGameTypeEnum) => {
                    this.removeChildControllerByName(`pointer_${type}`);
                },
            },
        };
    }

    protected onInitialize(): void {
        const miniGames = this._gameLogic.getMiniGames();
        const miniGamesWithQuestPointers = this._gameLogic.getMiniGameWithQuestPointers();

        miniGames.forEach(miniGame => {
            if (miniGamesWithQuestPointers.includes(miniGame.type)) {
                this.addChildController(
                    {
                        controller: UIQuestPointerController,
                        model: miniGame,
                    },
                    `pointer_${miniGame.type}`,
                    0,
                );
            }
        });
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.x = 0;
        this.y = -height / scale / 2;
    }
}
